export enum HSGNameOption {
  RECRUITER = 'HSG Recruiter',
  STRIKE_QUEUE = 'HSG Strike Queue',
}
